/*
* 主入口
*/

import './css/app.css';
// import '@ant-design/v5-patch-for-react-19';
import { useState, useEffect } from 'react';
import {
    Layout,
    message,
    ConfigProvider,
    theme,
} from 'antd';
import { createBrowserHistory } from 'history';
import cookie from 'react-cookies';
import $ from 'jquery';
import CNF from './incs/Config';
import {
    locale,
    AddRequestHeaders,
    DeleteCookies,
    winHeight,
} from './incs/FunHelper';

import ServiceReleaseMessage from './components/ServiceReleaseMessage';
import XHeader from './components/XHeader';
import XMenuLogo from './components/XMenuLogo';
import XMenu from './components/XMenu';
import XFooter from './components/XFooter';

// 配额管理
import QuotaToken from './pages/quotas/Token';
import QuotaImage from './pages/quotas/Image';

// 指令管理
import CommandPublic from './pages/commands/Public';
import CommandKeyword from './pages/commands/Keyword';

// 统计报表
import LogTTCD from './pages/reports/LogTTCD';
import LogTRCD from './pages/reports/LogTRCD';
import LogDMC from './pages/reports/LogDMC';

// 日志管理
import LogOpration from './pages/logs/LogOprations';
import LogApi from './pages/logs/LogApi';
import LogModel from './pages/logs/LogModel';
import QuotaRQTC from './pages/reports/QuotaRQTC';

// 主题色全局变量
global.THEMECOLOR = CNF.themeColors[0];

const { Sider, Content } = Layout;
const history = createBrowserHistory();
const { defaultAlgorithm, compactAlgorithm } = theme;
const Main = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [collapsed, setCollapsed] = useState(false);
    const [preGroup, setPreGroup] = useState('');
    const [navLists, setNavLists] = useState([]);
    const [btnLists, setBtnLists] = useState([]);
    const [serInfos, setSerInfos] = useState([]);

    // 切换模块
    const [m, setM] = useState(props.m);

    const {
        token: {
            colorWhite,             // 不随主题变化的纯白色
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            borderRadiusLG,
        },
    } = theme.useToken();

    useEffect(() => {
        $.ajax({
            url: `${CNF.api}policys`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                // 获取服务代码
                let serCodes = [];
                for (let i = 0; i < data.dat.nav_lists.length; i++) {
                    let serCode = data.dat.nav_lists[i].ptn.split('_')[1];
                    if (!serCodes.some(obj => obj === serCode)) {
                        serCodes.push(serCode);
                    }
                }
                setPreGroup(data.dat.pre_group);
                setNavLists(data.dat.nav_lists);
                setBtnLists(data.dat.btn_lists);
                setSerInfos(data.dat.ser_infos);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    // 若获取策略失败，直接退出登录
                    // DeleteCookies();
                }, CNF.messageDuration * 1000);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            setTimeout(function () {
                // 若获取策略失败，直接退出登录
                // DeleteCookies();
            }, CNF.messageDuration * 1000);
        });
    }, [messageApi]);


    useEffect(() => {
        var i;
        var j;
        // 更新 url
        if (m > 100) {
            i = Math.floor(parseInt(m) / 100);
            j = parseInt(m % 100)
            history.push(CNF.basename ? `${CNF.basename}${CNF.navItems[i - 1].submenu[j].url}` : CNF.navItems[i - 1].submenu[j - 1].url);
        }
        else if (m > 10) {
            i = Math.floor(parseInt(m) / 10);
            j = parseInt(m % 10)
            history.push(CNF.basename ? `${CNF.basename}${CNF.navItems[i - 1].submenu[j].url}` : CNF.navItems[i - 1].submenu[j - 1].url);
        } else {
            history.push(CNF.basename ? `${CNF.basename}${CNF.navItems[m - 1].url}` : CNF.navItems[m - 1].url);
        }
    }, [props.nav, m]);

    const setNavItem = (m) => {
        var com = ''
        switch (m.toString()) {
            case '11':
                com = <QuotaToken btnLists={btnLists} />;
                break;
            case '12':
                com = <QuotaImage btnLists={btnLists} />;
                break;
            case '21':
                com = <CommandPublic preGroup={preGroup} btnLists={btnLists} />;
                break;
            case '22':
                com = <CommandKeyword preGroup={preGroup} btnLists={btnLists} />;
                break;
            case '31':
                com = <LogTTCD collapsed={collapsed} btnLists={btnLists} />;
                break;
            case '32':
                com = <LogTRCD collapsed={collapsed} btnLists={btnLists} />;
                break;
            case '33':
                com = <LogDMC collapsed={collapsed} btnLists={btnLists} />;
                break;
            case '34':
                com = <QuotaRQTC collapsed={collapsed} btnLists={btnLists} />;
                break;
            case '41':
                com = <LogOpration btnLists={btnLists} />;
                break;
            case '42':
                com = <LogApi btnLists={btnLists} />;
                break;
            case '43':
                com = <LogModel btnLists={btnLists} />;
                break;
            default:
                break;
        }
        return com
    }

    return <ConfigProvider
        theme={{
            components: {
                Table: {
                    headerBorderRadius: 0,              //  表头圆角
                    headerBg: colorPrimaryBg,           // 表头背景色
                    headerSortHoverBg: colorPrimaryBg,  // 表头排序悬浮背景色
                    headerSortActiveBg: colorPrimaryBg, // 表头排序激活背景色
                    // rowHoverBg: colorPrimaryBg,         // 表格行悬浮背景色
                    borderColor: cookie.load(CNF.cookies.keyIsDisplayTableBorder) > 0 ? colorPrimaryBg : colorWhite, // 表格边框色
                    headerSplitColor: colorPrimaryBg,   // 表头分割线色
                },
                Tooltip: {
                    colorBgSpotlight: colorPrimary,
                },
                Select: {
                    optionActiveBg: colorPrimaryBg,
                },
            },
        }}
    >
        {/* 服务发布消息 */}
        <ServiceReleaseMessage themeColor={props.themeColor} serInfos={serInfos} />
        <Layout style={{ height: winHeight - 20.5 }}>
            {contextHolder}
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
            >
                <XMenuLogo collapsed={collapsed} />
                <XMenu
                    btnLists={btnLists}
                    navItems={CNF.navItems}
                    nav={'navItems'}
                    collapsed={collapsed}
                    setM={setM}
                    m={m}
                />
            </Sider>
            <Layout style={{
                background: colorPrimaryBg,
            }}>
                <XHeader
                    navLists={navLists}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    isCompact={props.isCompact}
                    setIsCompact={props.setIsCompact}
                    setThemeColor={props.setThemeColor}
                />
                <Content
                    style={{
                        margin: '20px 20px 0 20px',
                        // border: '1px solid red',
                        overflow: 'auto',
                        background: colorWhite,
                        borderRadius: borderRadiusLG,
                    }}
                >
                    {
                        setNavItem(m)
                    }
                </Content>
                <XFooter />
            </Layout>
        </Layout>
    </ConfigProvider>;

}

const Aadmin = (props) => {
    // 切换主体色
    const [themeColor, setThemeColor] = useState(cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0]);
    // 是否紧凑的
    const [isCompact, setIsCompact] = useState(false);
    return (
        <ConfigProvider
            locale={locale}
            variant='outlined'
            theme={{
                algorithm: isCompact ? compactAlgorithm : defaultAlgorithm,
                token: {
                    colorPrimary: themeColor,
                },
            }}
        >
            <Main
                m={props.m}
                nav={props.nav}
                themeColor={themeColor}
                setThemeColor={setThemeColor}
                isCompact={isCompact}
                setIsCompact={setIsCompact}
            />
        </ConfigProvider>
    )
};

export default Aadmin